import {BCMSRecord ,BCMSRecordProperty} from "bcms-react"; 
import {Account} from "../"
/**
* @class LoanAccount
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.checking[0];
* const account = new Account(record);
* @property {NUMBER} _mapID - number for account to use during mapping
* @property {bcmsCurrency} _due - amount due for current bill
* @property {bcmsCurrency} _lastPayment - amount paid on last payment
* @property {bcmsCurrency} _payoffAmount - total amount to pay off loan
* @property {bcmsCurrency} _principalBalance - total amount due for principal
* @property {bcmsCurrency} _escrowBalance - total amount due for escrow
* @property {STRING} _interestRate - interest rate percentage
* @property {bcmsDate} _dueDate - days in future when payment is due
* @property {bcmsDate} _currentBalance - currentBalance of the loan
* @property {bcmsCurrency} _availableCredit - The available credit of the loan
*/
export default class LoanAccount extends BCMSRecord{
    _mapID;   
    _due;  
    _lastPayment;   
    _payoffAmount;
    _principalBalance   
    _escrowBalance;
    _interestRate;
    _dueDate;
    _currentBalance; 
    _availableCredit;

    constructor (record){          
      super(Object.assign(record,Account.initByID(record.mapID).record))  
    }
  }  
  LoanAccount.define({
    "recordType":"loanAccounts",
    "recordIDProp":"mapID",
    "className" : "LoanAccount",
    "recordProperties": [
    /** 
    * @name mapID
    * @instance
    * @property get {NUMBER} - gets the mapID of the account
    * @property set {NUMBER} - sets the mapID of the account
    * @memberof LoanAccount 
    */
    BCMSRecordProperty.mapToNumber("mapID","_mapID"),
    /** 
    * @name due
    * @instance
    * @property get {bcmsCurrency} - gets the due of the account
    * @property set {bcmsCurrency} - sets the due of the account
    * @memberof LoanAccount 
    */
    BCMSRecordProperty.mapToCurrency("due","_due"),
    /** 
    * @name lastPayment
    * @instance
    * @property get {bcmsCurrency} - gets the lastPayment of the account
    * @property set {bcmsCurrency} - sets the lastPayment of the account
    * @memberof LoanAccount 
    */
    BCMSRecordProperty.mapToCurrency("lastPayment","_lastPayment"),
    /** 
    * @name payoffAmount
    * @instance
    * @property get {bcmsCurrency} - gets the payoffAmount of the account
    * @property set {bcmsCurrency} - sets the payoffAmount of the account
    * @memberof LoanAccount 
    */
    BCMSRecordProperty.mapToCurrency("payoffAmount","_payoffAmount"),
    /** 
    * @name principalBalance
    * @instance
    * @property get {bcmsCurrency} - gets the principalBalance of the account
    * @property set {bcmsCurrency} - sets the principalBalance of the account
    * @memberof LoanAccount 
    */
    BCMSRecordProperty.mapToCurrency("maturityDate","_principalBalance"),
    /** 
    * @name escrowBalance
    * @instance
    * @property get {bcmsCurrency} - gets the escrowBalance of the account
    * @property set {bcmsCurrency} - sets the escrowBalance of the account
    * @memberof LoanAccount 
    */
    BCMSRecordProperty.mapToCurrency("escrowBalance","_escrowBalance"),
    /** 
    * @name interestRate
    * @instance
    * @property get {STRING} - gets the interestRate of the account
    * @property set {STRING} - sets the interestRate of the account
    * @memberof LoanAccount 
    */
    BCMSRecordProperty.mapToString("interestRate","_interestRate"),
    /** 
    * @name dueDate
    * @instance
    * @property get {bcmsDate} - gets the dueDate of the account
    * @property set {bcmsDate} - sets the dueDate of the account
    * @memberof LoanAccount 
    */
    BCMSRecordProperty.mapToDate("dueDate","_dueDate"),
   /** 
    * @name currentBalance
    * @instance
    * @property get {bcmsCurrency} - gets the currentBalance of the account
    * @property set {bcmsCurrency} - sets the currentBalance of the account
    * @memberof LoanAccount 
    */
    BCMSRecordProperty.mapToCurrency("currentBalance","_currentBalance"),

    /**
     * @name availableCredit
     * @instance
     * @property get {bcmsCurrency} - gets the availableCredit of the account
     * @property set {bcmsCurrency} - sets the availableCreidt of the account
     * @memberof LoanAccount
     */
    BCMSRecordProperty.mapToCurrency("availableCredit", "_availableCredit")
].concat(Account._RecordProperties)
})




